module.exports = __webpack_public_path__ + "fi-rainforest-alliance-cocoa-hazelnut-59d077f460e779efb6505769d67e6956.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-rainforest-alliance-cocoa-hazelnut.png
// module id = 85
// module chunks = 0